<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between mb-4 font-weight-bold">
        <span class="">
          {{ $t(`manageBalance.planSummary.todaysTotal`) }}
        </span>
        <span>{{ totalPrice ? formatNumber(totalPrice) : '' }} €</span>
      </li>
      <!-- <li>
        <p class="font-weight-normal font-sm text-gray-500">
          {{ $t(`manageBalance.planSummary.summaryNote1`) }}
        </p>
        <p class="font-weight-normal font-sm text-gray-500">
          {{ $t(`manageBalance.planSummary.summaryNote2`) }}
        </p>
      </li> -->
    </ul>

    <CButton v-if="hasPurchases" color="primary w-100 py-3 font-xl my-3" @click.prevent="confirmpaymentintent" :disabled="loading">
      {{ $t(`manageplan.component.card.subTotal.button.pay`) }}
    </CButton>
  </CCardBody>
</template>

<script>
import services from '@/services.js'
import services2 from '@/services/services.js'
import { getItem } from '@/utils/StorageManager'
import { currencyFormat, currencyFormatStyleEnum } from '@/utils/numbersFormatUtil.js'

export default {
  name: 'CardTotals',
  props: {
    hasPurchases: {
      type: Boolean,
      default: false,
    },
    totalPrice: null,
  },

  data() {
    return {
      organizationId: null,
      stripe: null,
      loading: false,
      selectedPayment: this.$store.state.balance.steps.selectPayment || null,
      billingInfo: this.$store.state.balance.steps.billingInfo,
      customer: null,
      selectedPlan: this.$store.state.balance.steps.selectedPlan || JSON.parse(getItem('stateStep')).selectedPlan,
    }
  },

  created() {
    this.customer = this.$store.state.balance.steps.customer
    this.organizationId = this.$route.params.organizationId
  },

  computed: {
    lang() {
      return this.$store.state.lang
    },

    isSummary() {
      return this.place == 'summary'
    },

    cartPackges() {
      return this.$store.state.balance.steps.cartPackges
    },

    mount() {
      var count = 0
      this.cartPackges.forEach((pack) => (count = count + pack.package.packSelected.price * pack.quantity))
      return count
    },

    period() {
      return this.$store.state.balance.steps.paymentPeriod
    },
  },

  methods: {
    formatNumber(number) {
      return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
    },

    setModal(typeModal, message) {
      this.$store.dispatch('balance/steps/setModalComponent', { modalName: 'modalpayment', componentName: typeModal, messageModal: message })
    },

    closeModal() {
      this.$store.dispatch('balance/steps/closeModalComponent')
    },

    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },

    getSelectedAddonsByChannel(channel) {
      let emails = this.cartPackges.filter((item) => item.channel == channel)
      let selectedAddonsByChannel = []

      emails.forEach((elm) => {
        selectedAddonsByChannel.push({
          id: elm.package.packSelected.id,
          quantity: elm.quantity,
        })
      })

      return selectedAddonsByChannel
    },

    confirmpaymentintent() {
      this.loading = true
      var billingInfo = this.$store.state.balance.steps.billingInfo

      if (!billingInfo.detailCountry) {
        billingInfo.detailCountry = billingInfo.countryId == 'PT' ? 'portugal' : billingInfo.countryId
      }

      billingInfo.name = billingInfo.companyName

      var selectPayment = this.$store.state.balance.steps.selectPayment
      var customer = this.$store.state.balance.steps.customer
      var setupIntent = this.$store.state.balance.steps.setupIntent

      const info = {
        vatNumber: billingInfo.taxIdentificationNumber,
        billingInfo: billingInfo,
        period: this.period,
        stripePaymentMethodId: selectPayment.paymentId || null,
        setupIntent: setupIntent,
        setupIntentClientSecret: customer.setupSecret,
        addOnEmails: this.getSelectedAddonsByChannel('email'),
        addOnSmss: this.getSelectedAddonsByChannel('sms'),
      }

      if (this.selectedPlan) {
        info.planId = this.selectedPlan.planId
        info.planTierId = this.selectedPlan.selectedTierId
        info.periodPlanTierPriceId = this.selectedPlan.periodPlanTierPriceId
      }

      this.setModal('modalLoadingPayment')
      services
        .confirmpaymentintent(this.organizationId, info)
        .then(({ data }) => {
          const STRIPE = JSON.parse(JSON.stringify(data.data))

          if (data.data.status == 'processing') {
            this.stripePaymentIntentId(data.data.stripeJs)
          }

          if (data.data.status == 'requires_action') {
            this.pay(STRIPE.stripePaymentIntentClientSecretId, STRIPE.stripePaymentMethodId)
          }

          if (data.data.status == 'succeeded') {
            this.closeModal()
            this.setModal('ModalSuccessPayment')
            this.$store.dispatch('balance/steps/clearCart', null)
          }
        })
        .catch((error) => {
          const erros = error.response.data.errorParameters.reduce((acc, cur) => {
            if (acc == undefined) {
              acc = {}
            }

            if (cur.includes('ErrorCode:')) {
              acc.ErrorCode = cur.split(':')[1].trim()
            }

            if (cur.includes('DeclineCode:')) {
              acc.DeclineCode = cur.split(':')[1].trim()
            }

            return acc
          }, {})

          this.handleNotifyPaymentError(
            {
              error,
              errorCode: erros?.ErrorCode,
              declineCode: erros.DeclineCode,
            },
            customer.setupSecret,
          )

          // consegui simular apenas os erros CARD_DECLINED
          const message = `${erros?.ErrorCode}_${erros.DeclineCode ? erros.DeclineCode : ''}`
          this.setModal('ModalErrorPayment', message ? this.$t(`general.stripe.error.${message.toUpperCase()}`) : error.response.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleNotifyPaymentError({ error, errorCode, declineCode }, setupIntent, paymentMethodId) {
      const messageParts = [
        `🔴 Stripe Payment Error Report`,
        `Error Code: ${errorCode || 'N/A'}`,
        `Decline Code: ${declineCode || 'N/A'}`,
        `Stripe Payment Method ID: ${paymentMethodId || 'N/A'}`,
        `Message: ${error?.response?.data?.message || error?.message || 'No message available'}`,
        `Stack Trace:\n${error?.stack || JSON.stringify(error?.response?.data || {}, null, 2)}`,
      ]

      const formattedMessage = messageParts.join('\n\n')

      services2.notifyPaymentError(this.organizationId, {
        userId: this.$store.state.auth.user.id,
        stripeSetupIntent: setupIntent,
        errorMessage: formattedMessage,
      })
    },
  },
}
</script>

<style lang="scss">
p {
  line-height: 1.1rem;
}
</style>
